<template>
    <div id="ClaimDetails">
        <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"
            :height="150" :width="150" :color="'#FFFF00'" :background-color="'#000000'" :opacity="0.5">
        </loading>

        <div v-for="(item, index) in claimrecordItems" :key="index" class="cd-section">

            <!-- Section header card -->
            <div class="cd-header-card">
                <div class="cd-header-info">
                    <div class="cd-claim-type">{{ item.clmtypdesc }}</div>
                    <div class="cd-staff-name">
                        <v-icon size="13" color="#64748B" class="mr-1">mdi-account</v-icon>
                        {{ item.clmrecordd[0].staffno }} — {{ item.clmrecordd[0].staffname }}
                    </div>
                </div>
                <!-- Action bar -->
                <div class="cd-action-bar">
                    <v-btn class="cd-btn fbtn-success" small @click="approve('APPROVE')">
                        <v-icon size="14" class="mr-1">mdi-check</v-icon>
                        {{ $t('taskapprovemobile.approve') }}
                    </v-btn>
                    <v-btn class="cd-btn fbtn-danger" small @click="reject('REJECT')">
                        <v-icon size="14" class="mr-1">mdi-close</v-icon>
                        {{ $t('taskapprovemobile.reject') }}
                    </v-btn>
                    <v-btn class="cd-btn cd-btn-primary" small @click="finalApprove('FINAL APPROVE')">
                        <v-icon size="14" class="mr-1">mdi-check-all</v-icon>
                        {{ $t('taskapprovemobile.finalapprove') }}
                    </v-btn>
                </div>
            </div>

            <!-- Select All + count row (sticky, outside scroll) -->
            <div class="cd-select-all-row" @click="toggleSelectAllClick(item.id)">
                <span class="cd-record-count">{{ item.clmrecordd.length }} records</span>
                <v-icon size="18" :color="selectAllMap[item.id] ? '#4F6BFF' : '#94a3b8'" class="ml-auto">
                    {{ selectAllMap[item.id] ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
                </v-icon>
                <span class="cd-select-label">{{ $t('claimbalancemobile.selectall') }}</span>
            </div>

            <!-- Claim rows — scrollable -->
            <div class="cd-rows-scroll">
                <div v-for="(itemd, idx) in item.clmrecordd" :key="idx"
                    class="cd-row" :class="{ 'cd-row-alt': idx % 2 !== 0 }"
                    @click="$emit('claim-display-details', itemd)">
                    <div class="cd-row-content">
                        <span class="cd-type">{{ itemd.clmtypdesc }}</span>
                        <span class="cd-sep">·</span>
                        <span class="cd-date">{{ itemd.displaydate }}</span>
                        <span class="cd-sep">·</span>
                        <span class="cd-amount">{{ itemd.clmtypecrcycode }} {{ itemd.aprvamt }}</span>
                    </div>
                    <v-checkbox v-model="itemd.active" dense hide-details class="cd-check" @click.stop></v-checkbox>
                </div>
            </div>
        </div>

        <!-- Dialogs -->
        <app-alert-event v-bind:subDialog="subDialog" v-bind:subDialogId="subDialogId"
            v-bind:subDialogTitle="subDialogTitle" v-bind:subDialogText="subDialogText"
            v-bind:subDetailTask="subDetailTask" v-on:saveAction="saveAction" v-on:cancelAction="cancelAction" />
        <app-staff-list v-bind:subDialogStaffList="subDialogStaffList" v-bind:subDialogStaffListParam="subDialogStaffListParam"
            v-on:backAction="backAction" v-on:choosenPerson="choosenPerson" />
        <app-alert-error v-bind:errorDialog="errorDialog" v-bind:errorMessage="errorMessage" v-on:OkPressed="dismissHandler" />
        <app-alert-error2 v-bind:errorDialog="errorDialog2" v-bind:errorMessage="errorMessage2" v-on:OkPressed="goBackHandler" />
        <app-confirm v-if="continueOrSelectDialog" v-bind:parentObject="{ isConfirm: continueOrSelectDialog, messageConfirm: continueOrSelectMessage, showContinueOption: pendingContinueAllowed, showSelectOption: true, showCancelOption: false, okLabel: 'Continue', selectLabel: 'Select' }"
            v-on:confirm="continueOrSelectYes" v-on:selectConfirm="continueOrSelectSelect" />
    </div>
</template>

<script>

import AlertEvent from '../../sscomponents/common/AlertEvent.vue'
import Loading from "vue-loading-overlay";
import StaffListEvent from '../common/StaffList.vue'
import ErrorMessageSelService from '../../sscomponents/common/ErrorMessage.vue'
import ConfirmDialog from '../../components/common/ConfirmDialog.vue'

export default {

    props: {
        claimrecordItems: Array
    },

    components: {
        "app-alert-event": AlertEvent,
        "app-staff-list": StaffListEvent,
        "app-alert-error": ErrorMessageSelService,
        "app-alert-error2": ErrorMessageSelService,
        "app-confirm": ConfirmDialog,
        Loading
    },

    data(){
        return {
            subDialog: false,
            subDialogTitle: '',
            subDialogText: '',
            subDialogId: null,
            subDetailTask: null,

            loading: false,

            subDialogStaffList: false,
            subDialogStaffListParam: null,

            errorDialog: false,
            errorMessage: '',

            errorDialog2: false,
            errorMessage2: '',

            continueOrSelectDialog: false,
            continueOrSelectMessage: '',
            pendingApprovalValue: null,
            pendingSkipLevelNo: null,
            pendingContinueAllowed: true,

            selectAllMap: {}, // key: claim type id, value: boolean
        }
    },

    methods: {

        toggleSelectAllClick(clmtypeId) {
            let newValue = !this.selectAllMap[clmtypeId];
            this.$set(this.selectAllMap, clmtypeId, newValue);
            let claimType = this.claimrecordItems.find(item => item.id === clmtypeId);
            if (claimType) {
                claimType.clmrecordd.forEach(itemd => {
                    itemd.active = newValue;
                });
            }
        },

        // Error Message Popup Dismiss
        dismissHandler(){
            this.errorDialog = false
            this.errorMessage = ''
        },

        goBackHandler() {
            this.$router.push({ name: 'selfservicemytask' });
        },

        // To check only active item selected
        async checkActiveItem(action){

            let select = []

            for (let i = 0; i < this.claimrecordItems.length; i++) {
                let claimrecorddholder = this.claimrecordItems[i].clmrecordd.filter(val => {
                    val.apraction = action
                    return val.active
                })
                select.push(...claimrecorddholder)
            }

            return select

        },

        async finalApprove(action){

            let activeItem = await this.checkActiveItem(action);

            if(activeItem.length > 0){
                this.subDialogId = 1 //Final Approve ID
                this.subDialog = true
                this.subDialogTitle = this.$t('selfservicemytask.confirmfinapprove')
                this.subDialogText = this.$t('selfservicemytask.approvefintask')
                this.subDetailTask = activeItem
            } else {
                this.errorDialog = true
                this.errorMessage = this.$t('norectoprocess')
                // console.error(this.$t('norectoprocess'))
            }

        },

        async reject(action){

            let activeItem = await this.checkActiveItem(action);

            if(activeItem.length > 0){
                this.subDialogId = 2 //Reject ID
                this.subDialog = true
                this.subDialogTitle = this.$t('selfservicemytask.confirmrej')
                this.subDialogText = this.$t('selfservicemytask.rejecttask')
                this.subDetailTask = activeItem
            } else {
                this.errorDialog = true
                this.errorMessage = this.$t('norectoprocess')
                // console.error(this.$t('norectoprocess'))
            }
            
        },

        async approve(action){

            // Filter active item only
            let activeItem = await this.checkActiveItem(action);
            
            if(activeItem.length > 0){
                this.subDialogId = 3 //Approve ID
                this.subDialog = true
                this.subDialogTitle = this.$t('selfservicemytask.confirmapprove')
                this.subDialogText = this.$t('selfservicemytask.approvetask')
                this.subDetailTask = activeItem
            } else {
                this.errorDialog = true
                this.errorMessage = this.$t('norectoprocess')
                // console.error(this.$t('norectoprocess'))
            }

        },

        saveAction($event, param) {
            console.log('Save')
            console.log($event);
            console.log(param);

            // Perform Action to final approve
            if($event == 1){
                this.taskFinalApproval(param)
            }

            // Perform Action to reject
            if($event == 2){
                this.taskApproval('REJECT', param)
            }

            // Perform Action to approve
            if($event == 3){
                this.taskCheckApproval(param)
            }

            this.resetSubDialog();
        },

        cancelAction() {
            console.log('Cancel')
            this.resetSubDialog();
        },

        resetSubDialog(){
            this.subDialogId = null
            this.subDialog = false
            this.subDialogTitle = ''
            this.subDialogText = ''
            this.subDialogTask = null
            this.subDialogStaffList = false
            this.subDialogStaffListParam = null 
        },

        taskFinalApproval(param){

            const vm = this;
            vm.loading = true

            this.$store.dispatch('put', {url: "/finalapprovalworkflow/claim", payload: param})
            .then((res) => {
                const result = res.data;
                if (result.status === 200) {
                    vm.$router.push({name: 'selfservicemytask'});
                } else {
                    console.error(result.error);
                }

                vm.loading = false

            }).catch((err) => {
                vm.loading = false;
                console.error(err)
            });

        },

        taskApproval(text, value){

            value.apraction = text

            const vm = this;
            vm.loading = true;

            this.$store.dispatch('put', {url: "/approvalworkflow/claim/" + this.$store.getters.userId + '/' + this.$store.getters.staffId, payload: value})
            .then((res) => {
                const result = res.data;
                if (result.status === 200) {
                    if (result.needsContinueOrSelect) {
                        this.pendingApprovalValue = value
                        this.pendingSkipLevelNo = result.skipLevelNo
                        this.pendingContinueAllowed = result.continueAllowed !== false
                        this.continueOrSelectMessage = result.message
                        this.continueOrSelectDialog = true
                    } else if (result.waitingForCoApprover || result.workflowSetupIncomplete) {
                        this.errorMessage2 = result.message
                        this.errorDialog2 = true
                    } else {
                        vm.$router.push({name: 'selfservicemytask'});
                    }
                } else {
                    console.error(result.error);
                    this.errorMessage2 = "Failed to save the record"
                    this.errorDialog2 = true
                }

                vm.loading = false;

            }).catch((err) => {
                vm.loading = false;
                console.error(err)
                this.errorMessage2 = "Failed to save the record"
                this.errorDialog2 = true
            });

        },

        continueOrSelectYes() {
            this.continueOrSelectDialog = false
            const value = this.pendingApprovalValue
            this.pendingApprovalValue = null
            value.forEach(v => { v.continueSkip = true; v.skipLevelNo = this.pendingSkipLevelNo })
            this.taskApproval('APPROVE', value)
        },

        continueOrSelectSelect() {
            this.continueOrSelectDialog = false
            this.subDialogStaffListParam = this.pendingApprovalValue
            this.subDialogStaffList = true
        },

        taskCheckApproval(value) {
            // The server resolves who (if anyone) handles the next level - role-based,
            // reporting-position chain, or HR-final-handoff - and tells us via the approve
            // response if it needs a manual pick (needsContinueOrSelect), so just approve
            // directly and react to whatever it says.
            this.taskApproval('APPROVE', value)
        },

        // Staff List Action
        backAction(){
            this.subDialogStaffList = false
            this.subDialogStaffListParam = null
        },

        // Function receive from chosen staff to fill an empty approval level
        choosenPerson(id, data){
            this.subDialogStaffList = false
            data.forEach(v => { v.selectedApproverStaffId = id; v.skipLevelNo = this.pendingSkipLevelNo })
            this.taskApproval('APPROVE', data)
        }

    }
}

</script>

<style>
.cd-section {
    border-radius: 12px;
    border: 1px solid #E8EDF5;
    box-shadow: 0 1px 6px rgba(0,0,0,0.05);
    overflow: hidden;
    margin-bottom: 16px;
}

/* Header card */
.cd-header-card {
    background: linear-gradient(135deg, #1a3a5c 0%, #2d5a8e 100%);
    padding: 14px 16px 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
}
.cd-header-info { flex: 1; min-width: 0; }
.cd-claim-type {
    font-size: 0.95rem;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: normal;
    margin-bottom: 3px;
}
.cd-staff-name {
    font-size: 0.78rem;
    color: rgba(255,255,255,0.8);
    display: flex;
    align-items: center;
    letter-spacing: normal;
}

/* Action buttons */
.cd-action-bar {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    align-items: center;
    flex-shrink: 0;
}
.cd-btn {
    text-transform: none !important;
    letter-spacing: normal !important;
    font-size: 0.78rem !important;
    font-weight: 600 !important;
    border-radius: 8px !important;
    box-shadow: none !important;
    height: 32px !important;
}
.fbtn-success { background: #16A34A !important; color: #fff !important; }
.fbtn-danger { background: #E11D48 !important; color: #fff !important; }
.cd-btn-primary { background: #4F6BFF !important; color: #fff !important; }

/* Select All row */
.cd-select-all-row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 14px;
    background: #F8FAFF;
    border-bottom: 1px solid #E8EDF5;
    cursor: pointer;
    user-select: none;
}
.cd-select-label {
    font-size: 0.78rem;
    font-weight: 600;
    color: #475569;
    letter-spacing: normal;
}
.cd-record-count {
    font-size: 0.72rem;
    font-weight: 600;
    color: #4F6BFF;
    background: #EEF2FF;
    border-radius: 20px;
    padding: 2px 8px;
    letter-spacing: normal;
}

/* Scrollable rows container */
.cd-rows-scroll {
    background: #ffffff;
    max-height: 260px;
    overflow-y: auto;
}
.cd-rows-scroll::-webkit-scrollbar { width: 5px; }
.cd-rows-scroll::-webkit-scrollbar-track { background: #F8FAFF; }
.cd-rows-scroll::-webkit-scrollbar-thumb { background: #C7D2FE; border-radius: 3px; }

.cd-row {
    display: flex;
    align-items: center;
    padding: 8px 14px;
    border-bottom: 1px solid #F1F5F9;
    cursor: pointer;
    transition: background 0.12s;
}
.cd-row:last-child { border-bottom: none; }
.cd-row:hover { background: #F5F7FF !important; }
.cd-row-alt { background: #FAFBFF; }
.cd-row-content {
    flex: 1;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    font-size: 0.82rem;
    letter-spacing: normal;
}
.cd-type   { font-weight: 600; color: #4F6BFF; }
.cd-date   { color: #64748B; }
.cd-amount { font-weight: 700; color: #16A34A; }
.cd-sep    { color: #CBD5E1; margin: 0 6px; font-size: 0.7rem; }
.cd-check  { margin: 0 !important; padding: 0 !important; flex-shrink: 0; }
</style>